import React from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'
import Link from 'next/link'
import Image from 'next/image'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    title: `Ways to Apply for An Online Loan`,
    desc: 'Kredit Pintar FAQ about Cash Loan',
    learnMore: 'Learn More',
  },
  id: {
    title: `Cara Pinjam Uang Online Terkini dari Kredit Pintar`,
    desc: `Kredit Pintar FAQ seputar Pinjaman Uang Tunai`,
    learnMore: 'Lihat Tutorial',
  },
})

const LearnMore = () => {
  const { t } = useResource(resource)

  const learnMoreClick = () => {
    eventLogProducer.push({
      action: Action.LEARNMOREBUTTONCLICK,
    })
  }
  return (
    <div>
      <LearnMoreStyle>
        <div className="container">
          <div className="left">
            <Link href={'/faq'}>
              <a target="_blank" title={t('title')}>
                <h2 className="title">{t('title')}</h2>
              </a>
            </Link>
            <div className="des">{t('desc')}</div>
            <a
              onClick={learnMoreClick}
              href="https://www.youtube.com/embed/A3deNSGTBUs"
              rel="noopener noreferrer nofollow"
              target="_blank"
              className="btn"
            >
              <span>{t('learnMore')}</span>
            </a>
          </div>
          <div className="right">
            <div className="banner">
              <Reveal animation={Animation.FadeIn}>
                <LazyLoad>
                  <Image
                    src={'/images/home/banner1.png'}
                    alt="sub-banner"
                    width={377}
                    height={475}
                    quality={85}
                    placeholder="empty"
                  />
                </LazyLoad>
              </Reveal>
            </div>
          </div>
        </div>
      </LearnMoreStyle>
    </div>
  )
}

export default LearnMore

const LearnMoreStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 16px;
    .container {
      padding: 0 24px;
      position: relative;
      background-image: url('/images/home/mobile-bg2.png');
      background-size: cover;
      min-height: 635px;
      width: 100%;
      margin: 0 auto;
      img {
        width: 100%;
      }
      .left {
        padding-top: 58px;
        text-align: center;
        margin: 0 auto;
        .title {
          font-size: 24px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          line-height: 28px;
        }
        .des {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 32px;
          margin: 16px auto 31px;
        }
        .btn {
          width: fit-content;
          padding: 12px 36px;
          border-radius: 2000px;
          border: 2px solid #1cc812;
          cursor: pointer;
          font-size: 16px;
          font-family: OpenSans-Bold, OpenSans;
          font-weight: bold;
          color: #1cc812;
          line-height: 22px;
        }
      }
      .right {
        position: absolute;
        bottom: -3px;
        left: 50%;
        transform: translateX(-50%);
        width: 230px;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    margin-top: 22px;
    width: 1140px;
    margin: 0 auto;
    .container {
      background-image: url('/images/home/banner1-b.png');
      background-size: cover;
      height: 472px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 102px;
      img {
        width: 100%;
      }
      .left {
        padding-top: 90px;
        width: 594px;
        .title {
          font-size: 36px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          line-height: 48px;
        }
        .des {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 32px;
          margin: 20px 0 54px;
        }
        .btn {
          width: fit-content;
          padding: 12px 36px;
          border-radius: 2000px;
          border: 2px solid #1cc812;
          cursor: pointer;
          font-size: 16px;
          font-family: OpenSans-Bold, OpenSans;
          font-weight: bold;
          color: #1cc812;
          line-height: 22px;
        }
      }
      .right {
        width: 504px;
        display: flex;
        align-items: flex-end;
      }
    }
  }
`
